/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsFeaturedCollection = {
  init: function($section) {
    // Add settings from schema to current object
    window.PXUTheme.jsFeaturedCollection = $.extend(this, window.PXUTheme.getSectionData($section));

    if (this.collection_layout == 'slider') {
      this.createSlider($section.find('.slider-gallery--desktop'));
    }

    if (this.collection_layout_mobile == 'slider') {
      this.createSlider($section.find('.slider-gallery--mobile'));
    }
  },
  createSlider: function(el) {
    const slider = $(el);
    
    // Only initialize if the element exists
    if (slider.length === 0) {
      return;
    }

    $(slider).flickity({
      lazyLoad: 2,
      freeScroll: true,
      groupCells: true,
      imagesLoaded: true,
      draggable: true,
      wrapAround: false,
      pageDots: false,
      contain: true,
      prevNextButtons: this.products_limit > this.products_per ? true : false,
      initialIndex: 0,
      arrowShape: arrowShape,
    });

    $(slider).on('settle.flickity', () => $(slider).flickity('resize'));
  },
  unload: function($section) {
    let $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
}

/******/ })()
;